import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import _ from 'underscore';
import moment from 'moment';
import Mid2Col from '../containers/Mid2Col';
import MidListDD from '../containers/MidListDD';
import { acAxiosRequest } from '../actions/acAxiosRequest';
import { acLiveLot } from '../actions/acLiveLot'
import { acConSizeChange } from '../actions/acConSizeChange'
import { acRundaSelectata } from '../actions/acRundaSelectata'
import LottoLive from './LottoLive';
import Mid1ConNr from '../containers/Mid1ConNr';

class ColoanaMid extends React.Component {

    componentDidMount() {
        window.addEventListener('resize', this.updateWindowDimensions.bind(this));
        if (!this.props.popVizibil) {
            this.props.acConSizeChange({
                colMidW: 928,
            })
        }
        if (!this.props.activeLot && this.props.loterii && this.props.loterii.length > 0) {
            var axios = {
                ruta: this.props.appProps.ruta,
                request: 'get_rounds',
                reducer: 'RUNDE',
                value: 'lottery_name=' + this.props.loterii[0].name_lot.replace(/ /g, '_') + '&type=0',
                error: '3000',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(axios);
            this.props.acLiveLot(this.props.loterii[0].name_lot)
        }
        if (this.props.serverTime) {
            this.checkRoundExpired()
        }
    }
    componentWillUnmount() {
        this.interval && clearInterval(this.interval)
        this.interval = false
        this.timeout && clearTimeout(this.timeout)
        this.timeout = false
    }
    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.popVizibil) {
        //     console.log(prevProps.popVizibil, this.props.popVizibil);
        // }
        if (this.refColMid) {
            var dimensions = this.refColMid

            if (this.props.conSizeChange.colMidW !== dimensions.offsetWidth || this.props.conSizeChange.colMid !== dimensions.offsetHeight) {
                if (!this.props.popVizibil) {
                    this.props.acConSizeChange({
                        colMidW: dimensions.offsetWidth,
                        colMid: dimensions.offsetHeight
                    })
                }
            }
        }
        if (this.props.activeLot && this.props.runde && prevProps.runde) {
            if (moment(prevProps.runde[0].timeStart) < moment(this.props.runde[0].timeStart)) {
                var rundaSelect = {
                    gameType: this.props.activeLot.gameType,
                    id: this.props.runde[0].id,
                    round_unique: this.props.runde[0].round_unique,
                    selectedLot: this.props.runde[0].selectedLot,
                    timeStart: this.props.runde[0].timeStart
                }
                this.props.acRundaSelectata(rundaSelect)
            }
        }

    }
    updateWindowDimensions() {
        if (this.refColMid) {
            if (!this.props.popVizibil) {
                this.props.acConSizeChange({
                    colMidW: this.refColMid.offsetWidth,
                    colMid: this.refColMid.offsetHeight
                })
            }
        }
    }
    // componentDidUpdate(prevProps, prevState) {
    //     if ((prevProps.serverTime) && (this.props.serverTime)) {
    //         if (prevProps.serverTime.date_server_time !== this.props.serverTime.date_server_time) {
    //             this.checkRoundExpired()
    //         }
    //     }
    // }
    checkRoundExpired() {
        var date = this.props.serverTime.date_server_time
        var min = moment(date).minute()
        var sec = moment(date).second()

        if (min.toString().slice(-1) < 5) {
            var min5 = 5 - min.toString().slice(-1)
        }
        if (min.toString().slice(-1) >= 5) {
            min5 = 10 - min.toString().slice(-1)
        }
        // console.log('timp ramas min - sec:', min5, sec)
        var timer = (min5 * 60 * 1000) - sec * 1000;
        // var timeout
        // clearTimeout(timeout);
        this.timeout = setTimeout(function () {
            if (this.props.activeLot) {
                var lotName = this.props.activeLot.name_lot
            } else {
                lotName = this.props.loterii[0].name_lot
            }
            var axios = {
                ruta: this.props.appProps.ruta,
                request: 'get_rounds',
                reducer: 'RUNDE',
                value: 'lottery_name=' + lotName.replace(/ /g, "_") + '&type=0',
                error: '3110',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(axios);
            var axiosServerTime = {
                ruta: this.props.appProps.ruta,
                request: 'server_time',
                reducer: 'SERVER_TIME',
                error: '1110',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(axiosServerTime);
            // this.checkRoundExpired()
            this.interval(this.props.serverTime.date_server_time)

        }.bind(this), timer); // timer
    }

    interval(time) {
        // console.log('interval 5...5', this.props.serverTime.date_server_time);
        this.interval = setInterval(function () {
            if (this.props.activeLot) {
                var lotName = this.props.activeLot.name_lot
            } else {
                lotName = this.props.loterii[0].name_lot
            }
            var axios = {
                ruta: this.props.appProps.ruta,
                request: 'get_rounds',
                reducer: 'RUNDE',
                value: 'lottery_name=' + lotName.replace(/ /g, "_") + '&type=0',
                error: '3110',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(axios);
            var axiosServerTime = {
                ruta: this.props.appProps.ruta,
                request: 'server_time',
                reducer: 'SERVER_TIME',
                error: '1110',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(axiosServerTime);

        }.bind(this), 300000); // 5 minute
    }
    midType() {
        if (this.props.appProps.colMid === 'Mid2Col') {
            return <Mid2Col />
        }
        else if (this.props.appProps.colMid === 'MidListDD') {
            return <MidListDD />
        }
        else if (this.props.appProps.colMid === 'Mid1ConNr') {
            return <Mid1ConNr />
        }
        else {
            return <div></div>
        }
    }

    live() {
        if (this.props.appProps.live === true) {
            if (this.props.conSizeChange.appW && this.props.conSizeChange.appW >= 1000) {
                if (this.props.activeLot !== null) {
                    return (
                        <div className="con-lotto-resp-mid">
                            <LottoLive />
                        </div>
                    )
                } else {
                    return ''
                }
            }
        }
    }
    render() {
        // console.log('COLOANA MID***', this.props.rundaSelectata);
        return (
            <div ref={(f) => this.refColMid = f} className="col-mid">
                {this.live()}
                {this.midType()}
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        serverTime: state.serverTime,
        activeLot: state.activeLot,
        defaultVal: state.defaultVal,
        conSizeChange: state.conSizeChange,
        liveRounds: state.liveRounds,
        rundaSelectata: state.rundaSelectata,
        runde: state.runde,
        rundeActive: state.rundeActive,
        loterii: state.loterii,
        sessionParam: state.sessionParam,
        popVizibil: state.popVizibil
        // bilete: state.bilete,
        // biletTab: state.biletTab
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosRequest: acAxiosRequest,
        acLiveLot: acLiveLot,
        acConSizeChange: acConSizeChange,
        acRundaSelectata: acRundaSelectata
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(ColoanaMid);